/**
 * Seed data generator
 * Orchestrates generation of all seed data
 */

import { generateUsers } from './users.seed'
import { generateWorkspaces } from './workspaces.seed'
import { generateProjectsForWorkspaces } from './projects.seed'
import { generateTasksForProject } from './tasks.seed'
import { generateMessages } from './messages.seed'
import { generateDocuments } from './documents.seed'

/**
 * Generate all seed data with realistic relationships
 */
export function generateAllSeedData() {
  // 1. Generate users (15 users)
  const users = generateUsers(15)

  // 2. Generate workspaces (3 hard-coded workspaces: Axioma, ClarityOS, EthosAI)
  const workspaces = generateWorkspaces(users)

  // Ensure demo user (first user) is in at least one workspace
  const demoUser = users[0]
  if (!workspaces.some((w) => w.users.some((u) => u.id === demoUser.id))) {
    // Add demo user to the first workspace
    if (!workspaces[0].users.find((u) => u.id === demoUser.id)) {
      workspaces[0].users.push(demoUser)
    }
  }

  // Note: We don't populate reverse relationships to avoid circular references
  // The services will handle querying relationships by ID

  // 3. Generate pre-configured projects from templates and randomly assign to workspaces
  const allProjects = generateProjectsForWorkspaces(workspaces)

  // 4. Generate tasks for each project based on pre-configured templates
  const allTasks = allProjects.flatMap((project) => generateTasksForProject(project))

  // 5. Generate messages (~3 per project to reach ~50 total)
  const allMessages = allProjects.flatMap((project) => generateMessages(project, 3))

  // 6. Generate documents (~3 per project to reach ~50 total)
  const allDocuments = allProjects.flatMap((project) => generateDocuments(project, 3))

  return {
    users,
    workspaces,
    projects: allProjects,
    tasks: allTasks,
    messages: allMessages,
    documents: allDocuments,
  }
}

/**
 * Generate and export all mock data
 */
export const mockData = generateAllSeedData()
